// مركز تقارير تميز: التعلّم وتنفيذ البرامج (الملتحقون/البادئون/المنجزون، الاختبارات، الشهادات، التوزيع، مؤشرات الإدارة)
import ReportWizard, { Sel, UnitCascade, EmployeePicker } from "@/v2/components/ReportWizard";

const KINDS = [
  ["full", "تقرير شامل", "يجمع محاور التعلّم كلها: الملخص، التوزيع، البرامج والالتحاق والإنجاز، تقدم التعلّم، نتائج الاختبارات، مؤشرات الإدارة، الشهادات."],
  ["custom", "تقرير مخصص", "تحدد النطاق والفترة والمحاور ومستوى التفصيل — مثل تقرير دورة محددة، أو إدارة، أو موظف."],
];

const scope = ({ f, setF, opt }) => {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <>
      <UnitCascade units={opt.units || []} unitId={f.unit_id} onChange={set("unit_id")} />
      <Sel label="الإدارة (حسب ملف الموظف في تميز)" value={f.department} onChange={set("department")} options={(opt.departments || []).map((d) => ({ value: d, label: d }))} testId="rf-department" />
      <Sel label="المسار الوظيفي" value={f.track_id} onChange={set("track_id")} options={(opt.tracks || []).map((t) => ({ value: t.id, label: t.name }))} testId="rf-track" />
      <Sel label="المسمى الوظيفي" value={f.title_norm} onChange={set("title_norm")} options={(opt.titles || []).map((t) => ({ value: t.norm, label: t.title }))} testId="rf-title" />
      <Sel label="نوع الجدارة" value={f.category} onChange={set("category")} options={(opt.categories || []).map((s) => ({ value: s.key, label: s.label }))} testId="rf-category" />
      <Sel label="دورة محددة" value={f.program_id} onChange={set("program_id")} options={(opt.programs || []).map((p) => ({ value: p.id, label: p.title }))} testId="rf-program" />
      <EmployeePicker employees={opt.employees} value={f.user_id} onChange={set("user_id")} />
    </>
  );
};

const chips = (opt, f) => {
  const out = [];
  const u = (opt.units || []).find((x) => x.id === f.unit_id); if (u) out.push(`${u.kind_ar}: ${u.name}`);
  if (f.department) out.push(`الإدارة: ${f.department}`);
  const t = (opt.tracks || []).find((x) => x.id === f.track_id); if (t) out.push(`المسار: ${t.name}`);
  const ti = (opt.titles || []).find((x) => x.norm === f.title_norm); if (ti) out.push(`المسمى: ${ti.title}`);
  const st = (opt.categories || []).find((x) => x.key === f.category); if (st) out.push(`التصنيف: ${st.label}`);
  const p = (opt.programs || []).find((x) => x.id === f.program_id); if (p) out.push(`البرنامج: ${p.title}`);
  const emp = (opt.employees || []).find((x) => x.id === f.user_id); if (emp) out.push(`موظف: ${emp.name}`);
  return out;
};

export default function Reports() {
  return (
    <ReportWizard title="مركز تقارير تميز" testId="tamayoz-reports" storageKey="tamayoz-report-job"
      sub="تقارير PDF بالهوية الموحدة — التعلّم وتنفيذ البرامج، من مصدر الحساب نفسه الذي تعرضه اللوحة"
      optionsUrl="/admin/reports/v2/options" jobsUrl="/admin/reports/v2/jobs" fileBase="/api/admin/reports/v2/jobs"
      renderScope={scope} chips={chips} sections={(opt) => opt.sections || []} kinds={KINDS}
      fullDesc="التقرير الشامل يضم: الملخص، التوزيع حسب الجهات والمسميات، البرامج (الملتحقون/البادئون/المنجزون)، تقدم التعلّم، نتائج الاختبارات، أداء الإدارات والمتابعة وساعات المشاهدة، الشهادات، (تفاصيل الموظفين بحسب مستوى التفصيل) ودليل القراءة." />
  );
}
